var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Full_Screen",
    "data-name": "Icon / Full Screen",
    transform: "translate(-0.078)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148155",
    "data-name": "Rectangle 148155",
    width: 38,
    height: 35,
    rx: 10,
    transform: "translate(0.078)",
    opacity: 0.387
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-fullscreen",
    "data-name": "Icon material-fullscreen",
    d: "M9.819,17.934H7.5v5.8h5.8V21.412H9.819ZM7.5,13.3H9.819V9.819H13.3V7.5H7.5Zm13.912,8.115H17.934V23.73h5.8v-5.8H21.412ZM17.934,7.5V9.819h3.478V13.3H23.73V7.5Z",
    transform: "translate(3.616 1.56)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZoomIn);
export default __webpack_public_path__ + "static/media/Icon-ZoomIn.b32593eaa1d3795376c8824470fa18a1.svg";
export { ForwardRef as ReactComponent };